const sortAlphabetically = (a, b) => a.localeCompare(b);

export default sortAlphabetically;
